import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { Auth } from '../Enums/Auth.enum';
import { EMode } from '../Enums/EMode.enum';
import { ExchangeVersion } from '../Enums/ExchangeVersion.enum';

export class ExchangeMailClientConfig<T extends EMode = EMode.entity> {
  /** Alias: version */
  version?: ExchangeVersion;
  /** Alias: ewsUrl */
  ewsUrl?: string;
  /** Alias: serviceUserUsername */
  serviceUserUsername?: string;
  /** Alias: serviceUserPassword */
  serviceUserPassword?: string;
  /** Alias: serviceUserDomain */
  serviceUserDomain?: string;
  /** Alias: authMethod */
  authMethod?: Auth;
  /** Alias: clientId */
  clientId?: string;
  /** Alias: tenantId */
  tenantId?: string;
  /** Alias: clientSecret */
  clientSecret?: string;

  __typename?: string;
}

const fields: FieldDefinitions<ExchangeMailClientConfig> = {
  version: {
    alias: 'version',
  },
  ewsUrl: {
    alias: 'ewsUrl',
  },
  serviceUserUsername: {
    alias: 'serviceUserUsername',
  },
  serviceUserPassword: {
    alias: 'serviceUserPassword',
  },
  serviceUserDomain: {
    alias: 'serviceUserDomain',
  },
  authMethod: {
    alias: 'authMethod',
  },
  clientId: {
    alias: 'clientId',
  },
  tenantId: {
    alias: 'tenantId',
  },
  clientSecret: {
    alias: 'clientSecret',
  },
  __typename: {
    alias: '__typename',
  },
};

export const exchangeMailClientConfigEntityDefinition: EntitiyDefinition<ExchangeMailClientConfig> =
  {
    local: {},
    remote: {
      queryName: 'getGeneralEwsMailClientConfig',
      fragmentName: 'ExchangeMailClientConfig',
      withPaginationWrapper: false,
      mutations: {
        upsert: {
          mutationName: 'setGeneralEwsSettings',
          args: [{ name: 'input', type: 'InputExchangeMailClientConfig!' }],
        },
      },
    },
    fieldDefinitions: fields,
  };
